module.exports = __webpack_public_path__ + "static/media/19ESCAP11.0bf29d5a.jpg";